import { ThemedText, ThemedView } from '@app/theme';
const NumStepper = ({data,})=>{
    return(
        <>
        <ThemedView position='relative' >
            <ThemedView flexDirection='row' mb="2xl" flexWrap="wrap" alignItems="flex-start">
                <ThemedView width={32} height={32} borderRadius="full" backgroundColor="text-placeholder" borderWidth={6} borderColor="border-secondary" justifyContent="center" alignItems="center" >
                    <ThemedText variant='b5r' color='white' >1</ThemedText>
                </ThemedView>
                <ThemedView ml="md" flex={1}>
                    <ThemedText variant='b3s' color='text-primary'>{data[0]['heading']}{data[0].verticalDisplayName}</ThemedText>
                    <ThemedText variant='b4r' color="text-secondary">{data[0]['subHeading']}{data[0].verticalDescription}</ThemedText>
                </ThemedView>
            </ThemedView>
            <ThemedView position='absolute' left={15} top={15} zIndex={-1} height={75} width={1} backgroundColor='border-secondary' />
            <ThemedView flexDirection='row' mb="2xl" position='relative' flexWrap="wrap" alignItems="flex-start">
                <ThemedView width={32} height={32} borderRadius="full" backgroundColor="text-placeholder" borderWidth={6} borderColor="border-secondary" justifyContent="center" alignItems="center" >
                    <ThemedText variant='b5r' color='white' >2</ThemedText>
                </ThemedView>
                <ThemedView ml="md" flex={1}>
                    <ThemedText variant='b3s' color='text-primary'>{data[1]['heading']}{data[1].verticalDisplayName}</ThemedText>
                    <ThemedText variant='b4r' color="text-secondary">{data[1]['subHeading']}{data[1].verticalDescription}</ThemedText>
                </ThemedView>
            </ThemedView>
            {data.length>=3 &&
            <>
            <ThemedView position='absolute' left={15} bottom={50} zIndex={-1} height={100} width={1} backgroundColor='border-secondary' />
            <ThemedView flexDirection='row' flexWrap="wrap" alignItems="flex-start">
                <ThemedView width={32} height={32} borderRadius="full" backgroundColor="text-placeholder" borderWidth={6} borderColor="border-secondary" justifyContent="center" alignItems="center" >
                    <ThemedText variant='b5r' color='white' >3</ThemedText>
                </ThemedView>
                <ThemedView ml="md" flex={1}>
                    <ThemedText variant='b3s' color='text-primary'>{data[2]['heading']}{data[2].verticalDisplayName}</ThemedText>
                    <ThemedText variant='b4r' color="text-secondary">{data[2]['subHeading']}{data[2].verticalDescription}</ThemedText>
                </ThemedView>
            </ThemedView>
            </>
            }
        </ThemedView>
        </>
    )
}

export default NumStepper;